import React, { useEffect, useState, useRef, useContext } from 'react';
import { DownloadOutlined, UploadOutlined, DeleteOutlined, UserOutlined } from '@ant-design/icons';
import { Outlet, Link, useSearchParams, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button, Table, Popconfirm, Form, Input, Radio, DatePicker, Select, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import FormulaRule from '../formula_calculator/components/FormulaRule';
import FormulaRuleManage from '../formula_calculator/components/FormulaRuleManage';
import callWebApi from '../functions/callWebApi';

import dayjs from 'dayjs';
import MonthlySalaryManage from '../formula_calculator/components/MonthlySalaryManage';
import axios from 'axios';
const { RangePicker } = DatePicker;
const ClassTuitionFeeDetail = () => {
    const { Id } = useParams();
    const navigate = useNavigate();
    const [classId, setClassId] = useState(null);
    const [form] = Form.useForm();
    const [ClassList, setClassList] = useState([]);
    const [iSelectedRoleID, setSelectedRoleID] = useState(0);
    const [aFormulaRuleData, setFormulaRuleData] = useState([]);

    const uSubmit_OnClick = (aButtonData) => {
        //console.log("uSubmit_OnClick", aButtonData);
        form.setFieldsValue({ cFunction: aButtonData.function });
        form.submit();
    };
    const FormulaRule_onChange = (iKey, oData) => {
        console.log("onChange", iKey, oData);
        const aRows = [...aFormulaRuleData];
        aRows[iKey] = oData;
        setFormulaRuleData(aRows);
    }
    const FormulaRule_onDelete = (iKey, oData) => {
        console.log("onDelete", iKey, oData);
        const aRows = [...aFormulaRuleData];
        if (oData.iRuleID === 0) {
            aRows.splice(iKey, 1);
            setFormulaRuleData(aRows);
            return;
        }
        //#region 刪除資料
        callWebApi("/Salary/formulaRule/dataSave", { cSaveType: "delete", aData: [{ iRuleID: oData.iRuleID }] }, (oResponse) => {
            if (oResponse.bErrOn) { message.error(oResponse.message); return; }
            aRows.splice(iKey, 1);
            setFormulaRuleData(aRows);
        });
        //#endregion
    }
    const frmMain_OnFinish_Add = () => {
        const aRows = [...aFormulaRuleData];
        aRows.push({
            iRuleID: 0, iFormulaID: 5,
            iRoleID: iSelectedRoleID,
            fRangeBegin: 0, fRangeEnd: 0,
            iBaseFormulaID: 0, cOperator: "*", fNumeric: 1,
            iRound: 4
        });
        setFormulaRuleData(aRows);
    }
    const frmMain_OnFinish_Save = (aFormData) => {

        const aSaveData = [];
        let bHadError = false;
        Object.keys(aFormulaRuleData).forEach((iKey) => {
            const oSaveData = aFormData[`FormulaRule_${iKey}`];
            aSaveData[iKey] = oSaveData;
        }); if (bHadError) { return; }
        console.log("aSaveData", aFormulaRuleData);

        //#region 儲存資料
        // callWebApi("/Salary/formulaRule/dataSave", { cSaveType: "edit", aData: aFormulaRuleData }, (oResponse) => {
        //     if (oResponse.bErrOn) { message.error(oResponse.message); return; }
        //     message.success("儲存完成.");
        // });
        //#endregion
    }
    const frmMain_OnFinish = (aFormData) => {
        //console.log("frmMain_OnFinish", aFormData);
        switch (aFormData.cFunction) {
            case "add": frmMain_OnFinish_Add(); break;
            case "save": frmMain_OnFinish_Save(aFormData); break;
            default: break;
        }
    }
    const frmMain_OnFinishFailed = (aData) => {
    }
    const get_class = () => {
        axios
            .get('/cramSchool/api/class')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['class_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                setClassList(data_tmp);
            })
    }
    useEffect(() => {

        if (window.location.pathname == '/cramSchool/admin/CommonFeeDetail') {

        } else {
            if (Id) {
                document.title = '班級收費明細管理'
            }
            get_class();
        }
    }, [])
    return (
        <>
            <Row gutter={[8, 8]} justify={'space-between'} style={{ paddingTop: '20px' }}>
                {Id == undefined && window.location.pathname == '/cramSchool/admin/ClassTuitionFeeDetail' && (<>
                    <Col>
                        <Select
                            style={{ width: 200 }}
                            options={ClassList}
                            onChange={value => setClassId(value)} />
                    </Col>
                    <Col>
                        <Button type="primary" onClick={e => navigate(`/cramSchool/admin/ClassTuitionFeeDetail/${classId}`)}>搜尋</Button>
                    </Col>
                </>)}
                {Id && (<>
                    <Col span={24}>
                        <Form name="frmMain" form={form}
                            labelCol={{ span: 1 }} wrapperCol={{ span: 23 }} style={{ margin: "10px 10px" }}
                            onFinish={frmMain_OnFinish} onFinishFailed={frmMain_OnFinishFailed}
                            autoComplete="off"
                        >
                            <Col>
                                <Button
                                    onClick={frmMain_OnFinish_Add}
                                    type="primary"
                                    style={{
                                        marginBottom: 16,
                                        color: 'white',
                                        backgroundColor: '#2C73D2'
                                    }}
                                    shape='round'
                                    data-function="add"
                                >
                                    新增班級繳費明細
                                </Button>
                            </Col>
                            <Col span={24}>
                                {Object.keys(aFormulaRuleData).map(iKey => (
                                    <FormulaRule key={iKey} iKey={iKey} oData={aFormulaRuleData[iKey]}
                                        onChange={FormulaRule_onChange}
                                        onDelete={FormulaRule_onDelete}
                                    />
                                ))}
                            </Col>
                            <Col>
                                <Button data-function="save" className="ml-2" onClick={frmMain_OnFinish_Save} type='primary'>儲存</Button>
                            </Col>
                        </Form>
                    </Col>
                </>)}
                {window.location.pathname == '/cramSchool/admin/CommonFeeDetail' && (
                    <>
                        <Col span={24}>
                            <Form name="frmMain" form={form}
                                labelCol={{ span: 1 }} wrapperCol={{ span: 23 }} style={{ margin: "10px 10px" }}
                                onFinish={frmMain_OnFinish} onFinishFailed={frmMain_OnFinishFailed}
                                autoComplete="off"
                            >
                                <Col>
                                    <Button
                                        onClick={frmMain_OnFinish_Add}
                                        type="primary"
                                        style={{
                                            marginBottom: 16,
                                            color: 'white',
                                            backgroundColor: '#2C73D2'
                                        }}
                                        shape='round'
                                        data-function="add"
                                    >
                                        新增共同繳費明細
                                    </Button>
                                </Col>
                                <Col span={24}>
                                    {Object.keys(aFormulaRuleData).map(iKey => (
                                        <FormulaRule key={iKey} iKey={iKey} oData={aFormulaRuleData[iKey]}
                                            onChange={FormulaRule_onChange}
                                            onDelete={FormulaRule_onDelete}
                                        />
                                    ))}
                                </Col>
                                <Col>
                                    <Button data-function="save" className="ml-2" onClick={frmMain_OnFinish_Save} type='primary'>儲存</Button>
                                </Col>
                            </Form>
                        </Col>
                    </>
                )}
            </Row>
        </>
    )
}
export default ClassTuitionFeeDetail;